module.exports = __webpack_public_path__ + "img/earning.d4d6cca4.svg";